import moment from "moment/moment";

export default class RowObject {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = arg[c.nome] != undefined ? c.complex === false ? arg[c.nome] : JSON.parse(JSON.stringify(arg[c.nome])) : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }

    // Metodo per resettare tutte le campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "colore_colonna", default_val: "#FFFFFF", complex: false },
            { nome: "colore_riga", default_val: "#FFFFFF", complex: false },
            { nome: "colore_sfondo", default_val: "#FFFFFF", complex: false },
            { nome: "dimensione", default_val: 1, complex: false },
            { nome: "font_color_dato", default_val: "#000000", complex: false },
            { nome: "font_color_titolo", default_val: "#000000", complex: false },
            { nome: "font_size_icona", default_val: 50, complex: false },
            { nome: "font_size_dato", default_val: 20, complex: false },
            { nome: "font_size_titolo", default_val: 20, complex: false },
            { nome: "font_weight_dato", default_val: "normal", complex: false },
            { nome: "font_weight_titolo", default_val: "normal", complex: false },
            { nome: "id_layout", default_val: -1, complex: false },
            { nome: "id_layout_tmp", default_val: -1, complex: false },
            { nome: "id_layout_struttura", default_val: -1, complex: false },
            { nome: "id_layout_struttura_tmp", default_val: -moment().valueOf(), complex: false },
            { nome: "id_padre_tmp", default_val: null, complex: false },
            { nome: "intestazione", default_val: 0, complex: false },
            { nome: "ordine", default_val: 0, complex: false },
            { nome: "selezionata", default_val: 0, complex: false },
            { nome: "tipologia", default_val: "riga", complex: false },
            { nome: "validita", default_val: 1, complex: false },
            { nome: "colonne", default_val: [], complex: true },
        ];

        return campi;
    }
}